export const RATE_ESTIMATE_BID = process.env.GATSBY_RATE_ESTIMATE_BID || "";
